// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (orientation:landscape){.fastword-image,.play-image,.rewind-image{max-height:70%!important}}.image{width:100%;height:auto;transition:filter .5s ease}.my-contrast-switch{margin-left:300px;margin-right:20px}.black-and-white{opacity:.5}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
